/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

export default class ClearCreekResults extends React.Component {
    render() {
        const resultsComponent = this.props.results.map(
            ({ permitDisplayName, feeDisplayLabel }) => (
                <li key={`list-${permitDisplayName}`}>
                    <span className="permit-name">{permitDisplayName}.</span>&nbsp;
                    {feeDisplayLabel}*
                </li>
            )
        );
        return (
            <div className="permit-registeration-result">
                <p className="h2 permit-registeration-result-header">Results</p>
                <p>
                    Based on your answers please view the permits you will need for your
                    trip. Fees and other information may need to be provided. Select
                    &#39;Continue&#39; button to proceed to payment.
                </p>
                <ul>{resultsComponent}</ul>
                <p>*Each permit requires a $6 reservation fee.</p>
            </div>
        );
    }
}

ClearCreekResults.propTypes = {
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
};
